import React from 'react';
import * as _ from 'lodash';
import Helmet from 'react-helmet';

import {
  COMPANY_STANDARD_SETTING_DEFAULT,
  HEADER_CONSTANTS,
  COMPANY_STANDARD_SETTING_CONFIG_OPTION,
  STATUS_CODE,
} from '../utilities/constants';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import { isPrimeRoleId } from '../utilities/roleUtility';
import { calcOptionData } from '../utilities/commonUtil';
import dialogLoader from '../utilities/dialogLoader';
import { CompanyService } from '../services/Companies';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { PrimeGreenFileSettingService } from '../services/PrimeGreenFileSetting';

import { CloseEditView } from '../components/CloseEditView';
import { ArrowDownIcon } from '../components/icons/ArrowDownIcon';
import { MasterPageHeader } from '../components/PageHeader';
import { PrimaryCompanyNaviList } from '../components/list/PrimaryCompanyNaviList';
import {
  FormElement,
  FormList,
  FormListItem,
  FormListSubHeader,
} from '../components/CommonFormComponents';
import { FormInformationDialog } from '../components/FormInformationDialog';
import { Description } from '../components/Description';
import { messageUtility } from '../utilities/messageUtility';

class PrimeSafetySetting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      roleId: LocalStorageService.getRoleId(),
      companyId: SessionStorageService.getCompanyId(),
      formValues: {
        basis_senior_age: null,
        high_bp_systolic: null,
        high_bp_diastolic: null,
        low_bp_systolic: null,
        low_bp_diastolic: null,
      },
      isLoading: false,
      expirationCompany: {},
    };

    this.GoBack = {
      callback: {
        clear: () => {
          const id = this.props.view.state.id;
          if (id) {
            _masterSlideLoader.show('PrimeSafetySettingPreview', {
              state: { id },
            });
          } else {
            _masterSlideLoader.show('PrimeSafetySettingPreview', { state: {} });
          }
          dialogLoader.close();
        },
        close: () => {
          dialogLoader.close();
        },
      },
    };
    this.isSubmitingFlag = false;
  }

  getExpiration = async () => {
    await CompanyService.expirations(this.state.companyId).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        expirationCompany: {
          ...this.state.expirationCompany,
          ...response.data.entities.company.expiration,
        },
      });
    });
  };

  componentDidMount() {
    this.initializeData();
    this.getExpiration();
  }

  initializeData = async () => {
    this.setState({ isLoading: true });
    const response = await PrimeGreenFileSettingService.get(
      this.state.companyId
    );

    if (_.get(response, 'status') === STATUS_CODE.forbidden) {
      window.location.replace('/error-permission');
    }

    if (response.result) {
      const formValues = _.cloneDeep(this.state.formValues);
      const companyStandardSetting = _.get(
        response.data,
        'entities.company_standard_setting'
      );
      _.map(formValues, (value, key) => {
        formValues[key] = _.has(companyStandardSetting, key)
          ? _.get(companyStandardSetting, key)
          : COMPANY_STANDARD_SETTING_DEFAULT[key];
      });
      this.setState({ formValues, isLoading: false });
    }
  };

  handleGoBack = isEdit => {
    isEdit
      ? dialogLoader.show(CloseEditView, this.GoBack)
      : _masterSlideLoader.close();
  };

  handleSubmit = async () => {
    if (this.isSubmitingFlag) {
      return;
    }
    this.isSubmitingFlag = true;
    const response = await PrimeGreenFileSettingService.update(
      this.state.companyId,
      this.state.formValues
    );
    if (response.result) {
      dialogLoader.show(FormInformationDialog, {
        title: '会社情報 労務安全項目更新',
        message: '会社情報 労務安全項目の更新が完了しました。',
        buttonText: messageUtility.getMessage('I-000-017'),
        onClose: () => {
          dialogLoader.close();
          this.isSubmitingFlag = false;
          _masterSlideLoader.show('PrimeSafetySettingPreview', { state: {} });
        },
      });
    } else {
      if (_.get(response, 'status') === STATUS_CODE.forbidden) {
        dialogLoader.show(FormInformationDialog, {
          title: messageUtility.getMessage('E-001-402'),
          message:
            '編集中に別のユーザーが更新を行っている可能性があります。\n最新の内容をご確認のうえ、必要であれば再度編集を行ってください。',
          buttonText: messageUtility.getMessage('I-000-025'),
          onClose: () => {
            dialogLoader.close();
            this.isSubmitingFlag = false;
            _masterSlideLoader.show('PrimeCompanyPreview', { state: {} });
          },
        });
      } else {
        dialogLoader.show(FormInformationDialog, {
          title: messageUtility.getMessage('E-001-402'),
          message: '不正なパラメータです。',
          buttonText: messageUtility.getMessage('I-000-017'),
          onClose: () => {
            dialogLoader.close();
            this.isSubmitingFlag = false;
          },
        });
      }
    }
  };

  setPrimeSafetySettingEdit = () => {
    _masterSlideLoader.show('PrimeSafetySettingEdit', {
      state: {
        id: this.state.companyId,
      },
    });
  };

  handleOnChange = e => {
    const { name, value } = e.target;
    const formValues = _.cloneDeep(this.state.formValues);
    formValues[name] = Number(value);
    this.setState({ formValues });
  };

  render() {
    const { formValues, isLoading } = this.state;
    const { isEdit } = this.props;

    return (
      <div
        id='slide-view'
        className='contruction-slide-view show PrimeSafetySetting'
      >
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - 会社情報</title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title={'会社情報'}
            onClose={() => this.handleGoBack(isEdit)}
          />
          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__sidemenu'>
                <PrimaryCompanyNaviList
                  isSelectedPrimeSafetySettingInfo={true}
                  isEditable={isEdit}
                  expirationCompany={this.state.expirationCompany}
                />
              </div>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                {isPrimeRoleId(this.state.roleId) && (
                  <React.Fragment>
                    <div className='contruction-detail-view__menu'>
                      {isEdit ? (
                        <React.Fragment>
                          <span className='construction-detail-view__button'>
                            <button
                              className='btn--sub'
                              onClick={() => this.handleGoBack(isEdit)}
                            >
                              編集をやめる
                            </button>
                          </span>
                          <span className='construction-detail-view__button'>
                            <button
                              className='btn--effective'
                              onClick={this.handleSubmit}
                              data-testid={'register-btn'}
                            >
                              更新
                            </button>
                          </span>
                        </React.Fragment>
                      ) : (
                        <span className='construction-detail-view__button'>
                          <button
                            className='btn'
                            onClick={this.setPrimeSafetySettingEdit}
                          >
                            編集
                          </button>
                        </span>
                      )}
                    </div>
                    <div className='contruction-detail-view__bar' />
                  </React.Fragment>
                )}
                <div className='contruction-detail-view__main contruction-detail-view__main--fix contruction-detail-view__main--fixed'>
                  <FormList>
                    <FormListSubHeader title='高齢者情報' noMarginTop={true} />
                    <div className='form-list-default__ExceptionalItems'>
                      <Description>
                        自社の高齢者の基準年齢がデフォルトと異なる場合は設定を変更してください。
                        <br />
                        設定した基準年齢で「高齢者就労報告書」の対象作業員が抽出されます。
                        <br />
                        また、「現場内作業員検索」の検索条件の初期値に設定されます。
                        <br />
                        この項目を編集すると「Buildee労務安全」を利用しているすべての現場に設定が反映されます。
                      </Description>
                    </div>
                    <FormListItem label='高齢者の基準年齢'>
                      {!isLoading && (
                        <FormElement
                          info={
                            isEdit && '※デフォルトは「60歳以上」となります。'
                          }
                        >
                          {!isEdit ? (
                            <span>{formValues.basis_senior_age}歳以上</span>
                          ) : (
                            <React.Fragment>
                              <select
                                name='basis_senior_age'
                                onChange={this.handleOnChange}
                                value={formValues.basis_senior_age}
                              >
                                {_.map(
                                  calcOptionData(
                                    COMPANY_STANDARD_SETTING_CONFIG_OPTION.basis_senior_age
                                  ),
                                  (data, index) => (
                                    <option
                                      key={`basis_senior_age-${index}`}
                                      value={data.value}
                                    >
                                      {data.name}
                                    </option>
                                  )
                                )}
                              </select>
                              <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
                            </React.Fragment>
                          )}
                        </FormElement>
                      )}
                    </FormListItem>
                    <FormListSubHeader title='高血圧・低血圧情報' />
                    <div className='form-list-default__ExceptionalItems'>
                      <Description>
                        自社の高血圧・低血圧の基準がデフォルトと異なる場合は設定を変更してください。
                        <br />
                        「現場内作業員検索」の検索条件の初期値に設定されます。
                        <br />
                        この項目を編集すると「Buildee労務安全」を利用しているすべての現場に設定が反映されます。
                      </Description>
                    </div>
                    <FormListItem label='高血圧の基準'>
                      {!isLoading && (
                        <FormElement
                          info={
                            isEdit &&
                            '※デフォルトは最高血圧（上）：「140以上」、最低血圧（下）：「90以上」となります。'
                          }
                        >
                          <div className='blood-pressure-form'>
                            <div className='blood-pressure-form__item'>
                              <label className='blood-pressure-form__label'>
                                上
                              </label>
                              {!isEdit ? (
                                <span>{formValues.high_bp_systolic}以上</span>
                              ) : (
                                <React.Fragment>
                                  <select
                                    name='high_bp_systolic'
                                    onChange={this.handleOnChange}
                                    value={formValues.high_bp_systolic}
                                  >
                                    {_.map(
                                      calcOptionData(
                                        COMPANY_STANDARD_SETTING_CONFIG_OPTION.high_bp_systolic
                                      ),
                                      (data, index) => (
                                        <option
                                          key={`high_bp_systolic-${index}`}
                                          value={data.value}
                                        >
                                          {data.name}
                                        </option>
                                      )
                                    )}
                                  </select>
                                  <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
                                </React.Fragment>
                              )}
                            </div>
                            <div className='blood-pressure-form__item'>
                              <label className='blood-pressure-form__label'>
                                下
                              </label>
                              {!isEdit ? (
                                <span>{formValues.high_bp_diastolic}以上</span>
                              ) : (
                                <React.Fragment>
                                  <select
                                    name='high_bp_diastolic'
                                    onChange={this.handleOnChange}
                                    value={formValues.high_bp_diastolic}
                                  >
                                    {_.map(
                                      calcOptionData(
                                        COMPANY_STANDARD_SETTING_CONFIG_OPTION.high_bp_diastolic
                                      ),
                                      (data, index) => (
                                        <option
                                          key={`high_bp_diastolic-${index}`}
                                          value={data.value}
                                        >
                                          {data.name}
                                        </option>
                                      )
                                    )}
                                  </select>
                                  <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
                                </React.Fragment>
                              )}
                            </div>
                          </div>
                        </FormElement>
                      )}
                    </FormListItem>
                    <FormListItem label='低血圧の基準'>
                      {!isLoading && (
                        <FormElement
                          info={
                            isEdit &&
                            '※デフォルトは最高血圧（上）：「100以下」、最低血圧（下）：「60以下」となります。'
                          }
                        >
                          <div className='blood-pressure-form'>
                            <div className='blood-pressure-form__item'>
                              <label className='blood-pressure-form__label'>
                                上
                              </label>
                              {!isEdit ? (
                                <span>{formValues.low_bp_systolic}以下</span>
                              ) : (
                                <React.Fragment>
                                  <select
                                    name='low_bp_systolic'
                                    onChange={this.handleOnChange}
                                    value={formValues.low_bp_systolic}
                                  >
                                    {_.map(
                                      calcOptionData(
                                        COMPANY_STANDARD_SETTING_CONFIG_OPTION.low_bp_systolic
                                      ),
                                      (data, index) => (
                                        <option
                                          key={`low_bp_systolic-${index}`}
                                          value={data.value}
                                        >
                                          {data.name}
                                        </option>
                                      )
                                    )}
                                  </select>
                                  <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
                                </React.Fragment>
                              )}
                            </div>
                            <div className='blood-pressure-form__item'>
                              <label className='blood-pressure-form__label'>
                                下
                              </label>
                              {!isEdit ? (
                                <span>{formValues.low_bp_diastolic}以下</span>
                              ) : (
                                <React.Fragment>
                                  <select
                                    name='low_bp_diastolic'
                                    onChange={this.handleOnChange}
                                    value={formValues.low_bp_diastolic}
                                  >
                                    {_.map(
                                      calcOptionData(
                                        COMPANY_STANDARD_SETTING_CONFIG_OPTION.low_bp_diastolic
                                      ),
                                      (data, index) => (
                                        <option
                                          key={`low_bp_diastolic-${index}`}
                                          value={data.value}
                                        >
                                          {data.name}
                                        </option>
                                      )
                                    )}
                                  </select>
                                  <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
                                </React.Fragment>
                              )}
                            </div>
                          </div>
                        </FormElement>
                      )}
                    </FormListItem>
                  </FormList>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export class PrimeSafetySettingPreview extends React.Component {
  render() {
    return <PrimeSafetySetting {...this.props} />;
  }
}

export class PrimeSafetySettingEdit extends React.Component {
  render() {
    return <PrimeSafetySetting {...this.props} isEdit={true} />;
  }
}



// WEBPACK FOOTER //
// ./src/pages/PrimeSafetySetting.jsx